import React from "react";
import icons from "../../../../../assets/images/icons";
import styles from "./Toast.module.scss";

/**
 * 공통 토스트 (Figma 40004313:38129 — Toast/Toast)
 * - 상태 안내 메시지 + 녹색 체크 아이콘
 * - message 없으면 렌더하지 않음
 */
function Toast({ message, "data-node-id": dataNodeId }) {
  if (message == null || message === "") return null;

  return (
    <div
      className={styles.wrap}
      role="status"
      {...(dataNodeId ? { "data-node-id": dataNodeId } : {})}
    >
      <div className={styles.icon}>
        {icons.messager?.check && (
          <img
            src={icons.messager.checkGreen}
            alt=""
            className={styles.iconImg}
          />
        )}
      </div>
      <p className={styles.message}>{message}</p>
    </div>
  );
}

export default Toast;
